import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';
import {TextAlignment} from '@fo/shared/styles/variables/fonts';

const styles = {
  informationBox: (align: TextAlignment, hasBorder = false): string => css`
    label: informationBox;
    margin: ${spacing.M} ${spacing.XS};
    padding: ${spacing.M} ${spacing.XXS};
    background-color: ${colours.background.MAIN};

    text-align: ${align};
    ${hasBorder ? `border: 10px solid ${colours.border.LIGHT_GRAY};` : ''};

    ${mq(Breakpoints.TABLET)} {
      margin: ${spacing.M};
      padding: ${spacing.M};
    }
  `,
  copy: css`
    label: informationBox__copy;
    color: ${colours.font.ASSISTIVE};
  `,

  icon: css`
    label: informationBox__icon;
    justify-content: center;
    display: flex;
  `,
};

export default styles;
